export class ObjectTools {
  static objChanged<T extends object, K extends keyof T>(prev: T, curr: T): boolean {
    const keysPrev: K[] = Object.keys(prev) as K[];
    const keysCurr: K[] = Object.keys(curr) as K[];
    const uniqueAllKeys = [...new Set([...keysPrev, ...keysCurr])];

    if (
      keysPrev.length !== keysCurr.length
      || uniqueAllKeys.length > keysPrev.length
      || uniqueAllKeys.length > keysCurr.length
    ) {
      return true;
    }
    return keysPrev.some(prevKey => {
      const prevValue = prev[prevKey];
      const currValue = curr[prevKey];
      return prevValue !== currValue;
    });
  }
}
